/* eslint-disable no-console */

import { register } from 'register-service-worker'

if(navigator.serviceWorker){
    navigator.serviceWorker.getRegistrations().then(
        function(registrations) {
            for(let registration of registrations) {
                registration.unregister();
            }
        }
    ); 
}

// we disable the offline cache
//if (process.env.NODE_ENV === 'production') {
if(false) {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updated () {
      console.log('New content is available; please refresh.')
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
